import React, { useContext } from 'react'
import { Icon } from 'semantic-ui-react'
import { AuthContext } from '@dexter-experts/auth-react'
import { REFERRAL_PARTNERS } from '../constants/referralPartners'

const BENEFITS = [
  { icon: 'dollar sign', text: 'Receive payments quickly & securely' },
  { icon: 'calendar outline', text: 'Schedule calls at your convenience' },
  { icon: 'lightbulb outline', text: 'Learn about new, cutting-edge products' },
]

const Landing = ({ partner }) => {
  const { goToAuth } = useContext(AuthContext)
  const partnerInfo = partner ? REFERRAL_PARTNERS[partner] : null

  return (
    <div id="landing" className={partnerInfo ? 'partner-landing' : undefined}>
      <section className="intro">
        <a
          className="logo"
          href="https://www.dexterexperts.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Dexter Experts home"
        >
          DEXTER
        </a>
        <div className="content">
          <h1>
            Share insights.
            <br />
            Monetize your expertise.
            <br />
            Make an impact.
          </h1>
          <p>Get paid for your insights through 1:1 interviews and surveys.</p>
          <ul>
            {BENEFITS.map(({ icon, text }) => (
              <li key={text}>
                <Icon name={icon} />
                {text}
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className="login">
        <div className="contact">
          {'Questions? '}
          <a
            href="https://www.dexterexperts.com/contact/inquiry"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact our team
          </a>
        </div>
        <div className={`card${partnerInfo ? ' partner-card' : ''}`}>
          {partnerInfo && (
            <div className="partnership">
              <span>In partnership with</span>
              <img
                src={`${process.env.REACT_APP_AWS_S3_URL}/${partnerInfo.logo}`}
                alt={partnerInfo.name}
              />
            </div>
          )}
          <h2>Welcome to Dexter</h2>
          <p>
            See your project invitations, schedule calls, update your profile,
            and track payments.
          </p>
          <button type="button" onClick={() => goToAuth()}>
            Expert Login / Sign up
          </button>
        </div>
        <div className="client-login">
          {'Looking for experts? '}
          <a href={process.env.REACT_APP_CLIENT_APP_URL}>Client login →</a>
        </div>
      </section>
    </div>
  )
}

export default Landing
